import type { SubjectPayload } from '@Application/Subjects/Actions/subjectFetched';

export type SubjectCreatedAction = {
	type: 'SUBJECT_CREATED';
	payload: SubjectPayload;
};

export default (payload: SubjectPayload): SubjectCreatedAction => ({
	type: 'SUBJECT_CREATED',
	payload,
});
